import { convertToArray } from "../../Config/functions";


export const TherapyPreference = (props:any) => {
    const {preferred_language,therapy_delivery_modes,therapy_type } = props.treatment_preferences;
    const {languages_known} = props.client_information;
    return (
        <div className="col-sm-4 mt-5 " >
            <h4>Therapy Preferences</h4>
            <table className="table table-striped  mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Therapy Delivery Mode:</th>
                        <td>{therapy_delivery_modes.length>0 ? therapy_delivery_modes.join(",")   :null}</td>
                    </tr>
                    <tr>
                        <th scope="row">Therapy Type:</th>
                        <td>{therapy_type.length>0 ? therapy_type.join(", ")  : null}</td>
                    </tr>
                    <tr >
                        <th scope="row" >Preferred Language:</th>
                        <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} >{languages_known? convertToArray(languages_known).map((el:any)=> el.label).join(","): ""}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
